// extracted by mini-css-extract-plugin
module.exports = {"NextArrow":"NextPrevArrow_NextArrow__NXJwT","PrevArrow":"NextPrevArrow_PrevArrow__36nSw"};